/* eslint max-len: ["error", { "code": 800 }] */
import React from 'react';
import './AboutUs.scss';
import IconParticles from '../icon-particles/IconParticles';
import brandList from '../brand-service/assetsV2/brandsIndex1';

function AboutUs() {
  return (
    <main className="AboutUs">
      <div className="AboutUs__container">
        <section className="Hero" aria-label="FAQ Hero Section">
          <IconParticles />
        </section>

        <section className="Intro1" aria-label="Company Introduction">
          <div className="Intro__content">
            <header>
              <h1 className="Intro__content--title">About Us</h1>
            </header>
            <div className="Intro__content--details">
              <p>
                Noiz was conceptualized by a few passionate gamers seeing a gap in the gaming industry. Our goal is to support and provide tools for passionate streamers while amplifying marketing campaigns targeted at the video game audience.
              </p>
              <p>
                Our team is comprised of esports and gaming industry veterans- who have worked with companies like Major League Gaming, Riot Games, Activision, THQ, Fnatic, and more.
              </p>
              <p>
                We aim to help both aspiring game streamers and game companies alike reach a wider audience, diversify marketing spend and income streams, and build their own brands easily and professionally at large scale. If you want to revolutionize game influencer marketing by making it more fun and accessible to all streamers and game companies, check out our jobs page!
              </p>
            </div>
          </div>
        </section>

        <section className="Brands" aria-label="Partner Brands">
          <div className="Brands__content">
            <h3 className="Brands__content--title">BRANDS WE'VE WORKED WITH</h3>
            <div className="Brands__logos-wrapper" role="list" aria-label="Brand logos">
              {brandList.map((logo, i) => {
                // Extract brand name from logo path for better accessibility
                const brandName = logo.split('/').pop().split('.')[0].replace(/[-_]/g, ' ');
                return (
                  <div className="Brands__logos-wrapper--logo" key={i} role="listitem">
                    <img
                      alt={`${brandName} logo`}
                      src={logo}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default AboutUs;